import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CategoriesService {
	constructor() {}

	strip(categories: any[]): any[] {
		let stripped = [];
		categories.forEach((category) => {
			if (category['ads'] !== '0') {
				stripped.push(category);
			}
		});

		return stripped;
	}
}
